import { API, graphqlOperation } from 'aws-amplify';
import { customBenchmarkFormSettings } from '../constants/adminConstants';

const GET_CUSTOM_BENCHMARK = `
query FetchBenchmark($entityId: String!) {
  benchmarkConfig(entityId: $entityId, entityType: "district") {
    entityId
    entityType
    meta {
      enabled
      label
      scale
    }
    cutlines {
      id
      label
      grades {
        id
        seasons {
          id
          value
        }
      }
    }
  }
}`;

const SET_CUSTOM_BENCHMARK = `
mutation Benchmark($benchmarkData: BenchmarkConfigInput) {
  benchmarkConfig(input: $benchmarkData){
    entityId
    entityType
    meta {
      enabled
      label
      scale
    }
    cutlines {
      id
      label
      grades {
        id
        seasons {
          id
          value
        }
      }
    }
  }
}`

export async function setCustomBenchmark(rawBenchmarkData, scale, district) {
    let form = prepareFormForIngestion(rawBenchmarkData, scale, district);
    const data = await API.graphql(graphqlOperation(SET_CUSTOM_BENCHMARK, {benchmarkData: form}));
    return data;
}

// Set all appropriate fields, and convert string cutlines to float
function prepareFormForIngestion(benchmarkData, scale, district) {
  let form = benchmarkData;

  // Set appropriate fields
  form.entityId = district.id;
  form.entityType = "district";
  form.meta.label = district.label;
  form.meta.scale = scale.value;

  // Convert cutline strings to floats
  for(let z = 0; z < form.cutlines.length; z++) {
    let cutline = form.cutlines[z];
    for(let i = 0; i < cutline.grades.length; i++) {
      for(let j = 0; j < cutline.grades[i].seasons.length; j++) {
        let fieldValue;
        if(cutline.grades[i].seasons[j].value == '' || isNaN(parseFloat(cutline.grades[i].seasons[j].value))) {
          fieldValue = 0;
        } else {
          fieldValue = parseFloat(cutline.grades[i].seasons[j].value);
        }
        form.cutlines[z].grades[i].seasons[j].value = fieldValue;
      }
    }
  }

  return form;
}

export async function getCustomBenchmark(districtId, metric) {
  // Note: entityId is the districtId
  let entityId = districtId;
  const resp = await API.graphql(graphqlOperation(GET_CUSTOM_BENCHMARK, {entityId}));

  // If benchmark doesn't exist, or has incomplete fields
  // TODO don't hardcode cutlines.length check, or grades.length check
  if(!resp.data ||
    !resp.data.benchmarkConfig ||
    resp.data.benchmarkConfig.cutlines.length < 3 ||
    resp.data.benchmarkConfig.cutlines[0].grades.length < 6 ||
    (metric && resp.data.benchmarkConfig.meta.scale !== metric)
  ) {
    return getPlaceholderDefaultBenchmarkForm(districtId);
  }
  return resp.data.benchmarkConfig;
}

// Returns a blank form with placeholders for all necessary fields
export function getPlaceholderDefaultBenchmarkForm(districtId) {
    let form = {};

    // set districtId
    form.entityId = districtId;
    form.entityType = "district";

    // set metadata
    form.meta = {
      enabled: false,
      label: "UNSET",
      scale: "WCPM",
    }

    const defaultCutlineLabels = [
      "Catch Up",
      "On Track",
      "At/Above",
    ];

    // For each cutline, for each grade, for each season, create a form field
    form.cutlines = [];
    for(let i = 0; i < customBenchmarkFormSettings.numCutlines; i++) {
      let cutline = {
        id: i,
        label: defaultCutlineLabels[i] || ('Cutline ' + (i + 1)),
      }
      cutline.grades = customBenchmarkFormSettings.grades.map(grade => {
        let gradeData = {id: grade};
        gradeData.seasons = customBenchmarkFormSettings.seasons.map(season => {
          return { // create the form field
            id: season,
            value: '',
          }
        });
        return gradeData;
      });
      form.cutlines.push(cutline);
    }
    return form; // wrapper to match format returned from API
}

export default {
  setCustomBenchmark,
  getCustomBenchmark,
}

